import React from 'react';

const SearchIcon: React.FC = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
		<g fill="none" fillRule="evenodd">
			<path d="M0 0h24v24H0z" />
			<path
				d="m21.008 16.563-2.233-2.234a8.381 8.381 0 1 0-4.878 4.047l2.644 2.644c2.957 2.993 7.403-1.558 4.467-4.457zM5.045 10.331a6.323 6.323 0 1 1 6.323 6.324 6.33 6.33 0 0 1-6.323-6.324zm12.991 9.204-2.106-2.106a9.22 9.22 0 0 0 1.614-1.35l1.978 1.98a1.048 1.048 0 0 1-1.486 1.476z"
				fill="#b1b1b1"
				fillRule="nonzero"
			/>
		</g>
	</svg>
);

export default SearchIcon;
